



























































import { DashboardTabs, QueryParams } from "@/models/general";
import CampaignsAPI from "@/services/campaigns";
import { LayoutModule } from "@/store/layout";
import DashboardCampaignsTable from "./Components/DashboardCampaignsTable.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { get, isEqual } from "lodash";
import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import moment from "moment";
import FiltersHelper from "@/helpers/filters";
import UsersAPI from "@/services/users";
import User from "@/models/user";
import { DashboardFilter, DashboardModule } from "@/store/dashboard";
import Campaign, { CampaignFilters } from "@/models/campaign";
import { formatDate } from "@/helpers/dateHelpers";
import { exportCSVFile } from "@/helpers/general";

@Component({
  components: {
    DashboardCampaignsTable,
  },
})
export default class Home extends Vue {
  currentTab = "";
  users: User[] = [];
  tabs: DashboardTabs[] = [
    {
      id: "active-campaigns",
      label: "home.dashboard.active-campaigns",
      icon: "mdi-view-dashboard",
      data: [],
      meta: undefined,
      columns: ["name", "userId", "start", "end", "company", "status", "id"],
      loading: true,
      filter: {
        status: ["active", "changed", "reserved"],
        ref: [],
        dateRange: [
          moment().toDate().toString(),
          moment().add("1", "years").toDate().toString(),
        ],
        sort: {
          key: "end",
          order: "asc",
        },
      },
    },
    {
      id: "campaigns-to-start",
      label: "home.dashboard.campaigns_to_start",
      icon: "mdi-clock-time-ten-outline",
      data: [],
      meta: undefined,
      columns: ["name", "start", "company", "status", "id"],
      loading: true,
      filter: {
        status: ["active", "changed", "reserved"],
        start: {
          date: moment().toDate(),
          operator: "gte",
        },
        sort: {
          key: "start",
          order: "asc",
        },
      },
    },
    {
      id: "campaigns-to-end",
      label: "home.dashboard.campaigns_to_end",
      icon: "mdi-timer-check",
      data: [],
      meta: undefined,
      columns: ["name", "end", "company", "status", "id"],
      loading: true,
      filter: {
        status: ["active", "changed", "reserved"],
        end: {
          date: moment().toDate(),
          operator: "gte",
        },
        sort: {
          key: "end",
          order: "asc",
        },
      },
    },
    {
      id: "recently-ended",
      label: "home.dashboard.recently-ended",
      icon: "mdi-octagon",
      data: [],
      meta: undefined,
      columns: ["name", "end", "company", "status", "id"],
      loading: true,
      filter: {
        status: ["ended"],
        // end: {
        //   date: moment().toDate(),
        //   operator: "lte",
        // },
        dateRange: [
          moment().subtract(2, "months").toDate().toDateString(),
          moment().toDate().toDateString(),
        ],
        sort: {
          key: "end",
          order: "desc",
        },
      },
    },
  ];

  get loading(): boolean {
    let l = true;
    this.tabs.forEach((tab) => {
      l = l && tab.loading;
    });
    return l;
  }

  get currentTabFilter(): CampaignFilters | null {
    return DashboardModule.getFilter;
  }

  created(): void {
    this.tabs.forEach((tab) => {
      const f: DashboardFilter = { id: tab.id, filter: tab.filter };
      DashboardModule.setFilter(f);
      this.getData(tab);
      this.getUsers();
    });

    DashboardModule.setCurrentFilterId(this.tabs[0].id);
    DashboardModule.setFilter({
      id: this.tabs[0].id,
      filter: this.tabs[0].filter,
    });
  }

  async getData(
    tab: DashboardTabs,
    filter?: CampaignFilters,
    pageSize = 10,
    returnData = false
  ): Promise<Campaign[]> {
    LayoutModule.showLoader();

    const currentPage = tab.meta ? tab.meta.pagination.current : 1;
    const size = tab.meta ? tab.meta.pagination.size : 10;

    const r = await CampaignsAPI.list(
      currentPage,
      pageSize === -1 ? pageSize : size,
      FiltersHelper.buildRequestFilters(filter ? filter : tab.filter)
    );

    if (!returnData) {
      tab.data = r.data;
      tab.meta = r.meta;
    }

    tab.loading = false;
    !this.loading ? LayoutModule.hideLoader() : null;

    return r.data;
  }

  async getUsers(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };

      const r = await UsersAPI.getUsers(params);
      this.users = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  getNextPage(payload: { pagination: any; dataId: string }): void {
    const tab = this.tabs.find((t) => t.id === payload.dataId);

    if (tab && tab.meta) {
      tab.meta.pagination.current = get(payload.pagination, "page");
      tab.meta.pagination.size = get(payload.pagination, "itemsPerPage");
      this.getData(tab, DashboardModule.currentFilter as CampaignFilters);
    }
  }

  resetFilter(): void {
    //
  }

  @Watch("currentTabFilter", { deep: true })
  applyFilter(): void {
    if (DashboardModule.current_filter_id === this.currentTab) {
      const tab = this.tabs.find((t) => t.id === this.currentTab);

      tab ? this.getData(tab, this.currentTabFilter as CampaignFilters) : null;
    }
  }

  onTabChange(): void {
    const f = DashboardModule.getFilters.find((f) => f.id === this.currentTab);
    DashboardModule.setCurrentFilterId(this.currentTab ? this.currentTab : "");
    f ? DashboardModule.setFilter(f) : null;
  }

  async exportCsv(tab: DashboardTabs): Promise<void> {
    const data = await this.getData(
      tab,
      DashboardModule.currentFilter as CampaignFilters,
      -1,
      true
    );

    const headers: string[] = [];
    tab.columns.forEach((c) => {
      headers.push(
        c !== "id" ? this.$t(`campaigns.model.${c}`).toString() : "Id"
      );
    });

    const items: any = [];

    data.forEach((d) => {
      const item = [
        d.name,
        this.getSellerName(d.userId),
        formatDate(moment(d.start).toDate()),
        formatDate(moment(d.end).toDate()),
        d.company?.name,
        this.$t(`campaigns.status_list.${d.status}`),
        d.id,
      ];

      items.push(item);
    });

    exportCSVFile(headers, items, `${tab.id}_${moment().format("YYYY_MM_DD")}`);
  }
  getSellerName(id: string): string {
    const u = this.users.find((e) => e.id === id);
    const name = u ? `${u.name} ${u.familyName}` : "";

    return name;
  }
}
